import React from "react";

import { IconProps } from "@/src/types/icons";
import styles from "./styles";

export default function Arrow({
  direction = "up",
  fill = "currentColor",
}: IconProps) {
  return (
    <svg
      className="w-[68px] h-[59px] sm:w-[100px] sm:h-[90px] md:w-[135px] md:h-[118px]"
      style={styles[direction]}
      viewBox="0 0 135 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.75 73.75L67.5 44.25L101.25 73.75"
        stroke={fill}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
